import script from "./ContactoView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactoView.vue?vue&type=script&setup=true&lang=js"

import "./ContactoView.vue?vue&type=style&index=0&id=6b5c3cbd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b5c3cbd"]])

export default __exports__